<template>
  <div>
    <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
      <el-form-item label="项目名称:" clearable>
        <el-input v-model.trim="searchForm.reProjectName" placeholder="请输入项目名称" />
      </el-form-item>
      <el-form-item label="原合同编号:" clearable>
        <el-input v-model.trim="searchForm.reOldContractNum" placeholder="请输入原合同编号" />
      </el-form-item>
      <el-form-item label="合同编号:">
        <el-input v-model.trim="searchForm.reNewContractNum" placeholder="请输入合同编号" />
      </el-form-item>
      <el-form-item label="供货单位:" prop="supplyCode">
        <el-input v-model.trim="searchForm.supplyCode" placeholder="请输入供货单位" />
      </el-form-item>
      <el-form-item label="订单时间:" prop="createBeginTime">
        <div class="rj-flex" style="width:260px;">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createBeginTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createEndTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="最终客户名称:" prop="rFinalCustomerName">
        <el-input v-model.trim="searchForm.rFinalCustomerName" placeholder="请输入最终客户名称" />
      </el-form-item>
      <el-form-item label="销售:">
        <el-input v-model.trim="searchForm.reSalesPersonName" placeholder="请输入销售名称" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="tableLoading" @click="searchCilck">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="rprojectName" label="项目名称" align="left" fixed="left" min-width="190">
          <!-- <template slot-scope="scope">
            <el-button type="text" @click="check(scope.row)">{{ scope.row.rprojectName }}</el-button>
          </template> -->
        </el-table-column>
        <el-table-column prop="roldContractNum" label="原合同编号" align="left" width="140" />
        <el-table-column prop="rnewContractNum" label="退换货合同编号" align="left" width="140" />
        <el-table-column prop="rcontractType" label="合同类型" align="left" width="140" />
        <el-table-column prop="rorderAmount" label="退换货订单金额" align="right" header-align="left" width="150">
          <template slot-scope="{ row }">
            {{ row.rorderAmount && Number(row.rorderAmount).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="changeActualAmont" label="实际结算金额" align="right" header-align="left" width="150" />
        <el-table-column prop="changeActualAmont" label="退换货实际结算金额" align="right" header-align="left" width="150" />
        <el-table-column prop="rsalesPersonName" label="销售" align="left" width="150" />
        <el-table-column prop="rcreatedTime" label="合同时间" align="left" width="150" />
        <el-table-column prop="handel" label="操作" align="left" fixed="right" width="80">
          <template slot-scope="scope">
            <el-button v-if="scope.row.assignFlag" type="text" @click="pay(scope.row)">
              分配
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { getListForAgent } from '../../../API/index';
export default {
  data () {
    return {
      searchForm: {
        strDocumentTitle: '',
        strSaleName: '',
        strStartTime: '',
        strEndTime: '',
        strCRMAccountName: '',
        contractStatus: 2
      },
      tableLoading: false,
      tableData: [
        {
          handel: 'dasasda'
        }
      ],
      page: {
        pageSize: 10,
        total: 100,
        currentPage: 1
      },
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.strStartTime) {
            return time.getTime() <= (new Date(this.searchForm.strStartTime)).getTime();
          }
          return false;
        }
      }
    };
  },
  components: {},
  computed: {

  },
  methods: {
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.doSearch();
    },
    doSearch () {
      this.tableLoading = true;
      getListForAgent({
        ...this.searchForm,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        this.tableLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.$set(this.tableData, 'removeVisible', false);
          this.page.currentPage = json.data.pageNum;
          this.page.total = json.data.total;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },

    searchCilck () {
      this.page.currentPage = 1;
      this.doSearch();
    },

    resetForm () {
      this.$refs.searchForm.resetFields();
      this.searchForm = {};
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.doSearch();
    },
    pay (row) {
      this.$router.push({ name: 'chiefReturnbPay', query: { contractId: row.rcontractId, rnewContractNum: row.rnewContractNum, roldContractNum: row.roldContractNum, rcontractType: row.rcontractType } });
    }
  },
  mounted () {
    this.doSearch();
  },
  activated () {

  },
  destroyed () {
  }
};
</script>
<style lang="scss"></style>
